export default __webpack_public_path__ + "static/media/pokedex.42827b78.jpg";